import { render, staticRenderFns } from "./guan.vue?vue&type=template&id=1a8bc402&scoped=true"
import script from "./guan.vue?vue&type=script&lang=js"
export * from "./guan.vue?vue&type=script&lang=js"
import style0 from "./guan.vue?vue&type=style&index=0&id=1a8bc402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bc402",
  null
  
)

export default component.exports